var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52941 7.20137H16C16.234 7.20137 16.4584 7.29618 16.6239 7.46494C16.7894 7.6337 16.8824 7.86259 16.8824 8.10125V17.1001C16.8824 17.3388 16.7894 17.5677 16.6239 17.7364C16.4584 17.9052 16.234 18 16 18H1.88235C1.64834 18 1.42391 17.9052 1.25844 17.7364C1.09296 17.5677 1 17.3388 1 17.1001V8.10125C1 7.86259 1.09296 7.6337 1.25844 7.46494C1.42391 7.29618 1.64834 7.20137 1.88235 7.20137H2.76471V6.30148C2.7642 4.88209 3.23375 3.50413 4.09723 2.39097C4.96071 1.2778 6.1675 0.494678 7.522 0.168543C8.8765 -0.157592 10.2993 -0.00762166 11.5598 0.594143C12.8202 1.19591 13.8445 2.21419 14.4665 3.48394L12.8879 4.28844C12.4437 3.38137 11.712 2.65392 10.8116 2.22405C9.9112 1.79417 8.89482 1.68707 7.92725 1.92009C6.95968 2.15312 6.09764 2.71262 5.4809 3.50788C4.86417 4.30314 4.52888 5.28754 4.52941 6.30148V7.20137ZM7.17647 11.7008V13.5006H10.7059V11.7008H7.17647Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPassword);
export default __webpack_public_path__ + "static/media/login_password.9b1487f18067501491010df9222aeea5.svg";
export { ForwardRef as ReactComponent };